<script setup lang="ts" name="OrganisationShipmentVesselTracking">
import type { useService } from '~/features/useService.js';

import Card from '~/components/Card.vue';
import VesselMap from '~/components/VesselMap.vue';

import type { IVesselVoyageData } from '~/types';

defineProps<{
  mapData?: IVesselVoyageData;
  serviceState: ReturnType<typeof useService>;
}>();
</script>

<template>
  <Card title="Vessel Location" data-test="vessel-location">
    <div class="h-[400px]">
      <VesselMap :mapData="mapData" :serviceState="serviceState" />
    </div>
  </Card>
</template>
